export default __webpack_public_path__ + "static/media/Odinson.398c4e58.ttf";